exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user__header[data-v-651b0f58]{background-color:#6aceff;padding:65px 20px 0}.user__header .backlink[data-v-651b0f58]{margin-bottom:5px}.user__header .user__header-title-container[data-v-651b0f58]{display:flex;align-items:flex-end}.user__header img[data-v-651b0f58]{width:100px;margin-left:35px}.user__header span[data-v-651b0f58]{color:#fff;font-family:ClanFFBlack;font-size:25px;margin-top:25px;text-transform:uppercase;flex:1;text-align:right}.user__header .search__field[data-v-651b0f58]{background-color:transparent;border:1px solid #008bd0;font-family:ClanPro;font-size:14px;color:#008bd0;width:100%;outline:none;height:45px;line-height:45px;padding:0 20px;border-radius:24px;margin-top:20px;margin-top:30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-651b0f58","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/User/UserHeader.vue
// module id = 532
// module chunks = 0